var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9BADBC",
    fillRule: "evenodd",
    d: "M3.876 4.423l4.13-4.13A1 1 0 019.268.168l.068.045a.739.739 0 01.112 1.138L3.793 7.006a1 1 0 01-1.414 0L.293 4.92a1 1 0 010-1.414l.043-.043a.95.95 0 011.412.078l.64.8a1 1 0 001.488.082z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default ForwardRef;